import Toastr from '../../../components/Toastr'

const parent = 'INVENTORY_'
const DEFAULT_STATE = {
  warehouses: [],
  warehouse: {},
  warehouse_inventories: [],
  meta: { pagination: {} },
  inventoriesMeta: { pagination: {} },
  editing: false,
  saving: false,
}

export default function warehouseReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let warehouses = []
  let updatedRecord = {}
  let changes = null

  switch (action.type) {
    case `${parent}WAREHOUSES_LOAD_PENDING`:
    case `${parent}WAREHOUSE_LOAD_PENDING`:
    case `${parent}WAREHOUSE_INVENTORIES_LOAD_PENDING`:
      return { ...state, saving: false }

    case `${parent}WAREHOUSE_CREATE_PENDING`:
    case `${parent}WAREHOUSE_UPDATE_PENDING`:
    case `${parent}WAREHOUSE_INVENTORY_CREATE_PENDING`:
      return { ...state, saving: true }

    case `${parent}WAREHOUSES_LOAD_REJECTED`:
    case `${parent}WAREHOUSE_LOAD_REJECTED`:
    case `${parent}WAREHOUSE_CREATE_REJECTED`:
    case `${parent}WAREHOUSE_UPDATE_REJECTED`:
    case `${parent}WAREHOUSE_DELETE_REJECTED`:
    case `${parent}WAREHOUSE_INVENTORIES_LOAD_REJECTED`:
    case `${parent}WAREHOUSE_INVENTORY_CREATE_REJECTED`:
      Toastr.handleShow(response?.data?.success, response?.data?.error, response?.status_code)
      return { ...state, saving: false }

    case `${parent}WAREHOUSES_LOAD_FULFILLED`:
      return {
        ...state,
        warehouses: response.warehouses || [],
        meta: response.meta || { pagination: {} },
        saving: false,
      }

    case `${parent}WAREHOUSE_LOAD_FULFILLED`:
      return {
        ...state,
        warehouse: response.warehouse || {},
        saving: false,
      }

    case `${parent}WAREHOUSE_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message, 201)
      return {
        ...state,
        warehouses: [...state.warehouses, response.warehouse],
        editing: false,
        warehouse: {},
        saving: false,
      }

    case `${parent}WAREHOUSE_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message, 201)
      warehouses = [...state.warehouses]
      updatedRecord = response.warehouse
      warehouses = warehouses.map(item => item.id === updatedRecord.id ? updatedRecord : item)
      return {
        ...state,
        warehouses,
        editing: false,
        warehouse: {},
        saving: false,
      }

    case `${parent}WAREHOUSE_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message || 'Warehouse deleted successfully', 201)
      return {
        ...state,
        warehouses: state.warehouses.filter(item => item.id !== response.id),
        editing: false,
        warehouse: {},
      }

    case `${parent}WAREHOUSE_INVENTORIES_LOAD_FULFILLED`:
      return {
        ...state,
        warehouse_inventories: response.warehouse_inventories || [],
        inventoriesMeta: response.meta || { pagination: {} },
        saving: false,
      }

    case `${parent}WAREHOUSE_INVENTORY_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta?.message, 201)
      return {
        ...state,
        warehouse_inventories: [...state.warehouse_inventories, response.warehouse_inventory],
        saving: false,
      }

    case `${parent}WAREHOUSE_EDIT`:
      changes = {
        editing: { id: action.id },
        warehouse: action.id === 'New' ? { status: 'active' } : state.warehouse,
      }
      return { ...state, ...changes }

    case `${parent}WAREHOUSE_EDIT_CANCEL`:
      return {
        ...state,
        editing: false,
        warehouse: DEFAULT_STATE.warehouse,
      }

    default:
      return state
  }
}
